module.exports = __webpack_public_path__ + "img/equall.37ff5de7.svg";